<template>
  <div class="node-box-content">
    <div class="head-row" v-if="title || $slots.title">
      <span v-if="title">{{ title }}</span>
      <slot name="title" />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.node-box-content {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 260px;
  flex-shrink: 0;
  cursor: pointer;
  color:#333;
  min-width: 80px;
  text-align:center;
  font-size: 12px;
  line-height: 1.8em;
  vertical-align: middle;
  min-height:20px;
  background: #F7F9FD;
  border-radius: 8px;
  .head-row {
    width: 100%;
    justify-content: space-between;
    padding: 13px 16px;
    border-bottom: 1px solid #F0F2F5;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
